import { FC, CSSProperties, forwardRef } from "react";
import DatePicker from "react-datepicker";
import { ReactComponent as CalendarIcon } from "@/assets/icons/calendar.svg";

import "react-datepicker/dist/react-datepicker.css";
import "./style.scss";

interface DatePickerPropsTypes {
  placeholder?: string;
  value: any;
  style?: CSSProperties;
  disabled?: boolean;
  onChange?: (e: any) => void;
  isError?: boolean;
  errorText?: string;
  withTime?: boolean;
  showMonthDropdown?: boolean;
  showYearDropdown?: boolean;
}

const DatePick: FC<DatePickerPropsTypes> = ({
  value,
  placeholder,
  style,
  disabled,
  onChange,
  isError,
  errorText,
  withTime = false,
  showMonthDropdown = false,
  showYearDropdown = false,
}) => {
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div
      style={style}
      className={`input-date-picker ${disabled ? "disabled" : ""} `}
      onClick={onClick}
      ref={ref}>
      <CalendarIcon />
      {!value ? placeholder : value}
    </div>
  ));

  const props = {};
  return (
    <>
      <div className={`date-picker-wrapper`}>
        <DatePicker
          selected={value}
          customInput={<ExampleCustomInput />}
          onChange={onChange}
          dateFormat={withTime ? "dd/MM/yyyy h:mm aa" : "dd/MM/yyyy"}
          disabled={disabled}
          showTimeInput={withTime}
          showMonthDropdown={showMonthDropdown}
          showYearDropdown={showYearDropdown}
          dropdownMode='select'
          // minDate={new Date()}
        />
        {isError && (
          <span className='datepic-component-error-text'>{errorText}</span>
        )}
      </div>
    </>
  );
};

export default DatePick;
